export const counterDefaultVal = {
    speed: {
        title: "Speed",
        unit: "mph",
        step: 5,
        min: 45,
        max: 70,
    },
    temperature: {
        title: "Outside Temperature",
        unit: "°",
        step: 10,
        min: -10,
        max: 40,
    }
}


// WEBPACK FOOTER //
// ./src/constants/counterDefaultVal.js